const EventEmitter = require('eventemitter3');

const BattleCalc = require('../../BattleCalc');
const HasOptionCondition = require('../../conditions/HasOptionCondition');
const { logError } = require('../../logger');

const SummonOption = function(battleState) {
  this.handle = 'summon_option';
  this.magic = true;
  this.help = true;

  this.eventEmitter = new EventEmitter();

  this.isLegal = function(actor, victim) {
    return victim.unit && victim.team===actor.team;
  };

  this.execute = function(actor, victim) {
    if (!actor || !actor.inPlay || !victim || (victim.unit&&!victim.inPlay)) {
      return { success: false };
    }

    var ability = BattleCalc.getEquippedAbility(actor, this.handle);

    try {
      const hasOption = new HasOptionCondition(actor, victim, battleState, ability.damage, ability.charges);
      hasOption.instigatorId = actor.uid;
      hasOption.ownerId = victim.uid;
      battleState.onUnitCondition(hasOption);

      var result = { success: true, hasOption };
      result.abilityHandle = this.handle;
      result.actorId = actor.uid;
      result.victimId = victim.uid;
      result.allPieces = battleState.allPieces;
      this.eventEmitter.emit('result', { success: true,hasOption });
    } catch (err) {
      logError(err, {
        module: 'SummonOption',
        func: 'execute',
        actor,
        victim,
      });

      return { success: false };
    }
  };
};
module.exports = SummonOption;
